<mat-card class="compare-card">
  <h3 class="card-title">{{ 'dashboard.historicalVsNew' | translate }}</h3>

  <div class="bars-container">
    <!-- Исторические поставщики -->
    <div class="bar-row">
      <div class="bar-label">
        <div class="label-dot historical"></div>
        <span class="label-text">{{ 'dashboard.historical' | translate }}</span>
      </div>

      <div class="bar-wrapper">
        <div class="bar-background">
          <div
            class="bar-fill historical"
            [style.width.%]="stats().historicalPct">
          </div>

          @if (stats().historicalValue === 0) {
            <div class="zero-indicator"></div>
          }
        </div>
      </div>
    </div>

    <!-- Новые поставщики -->
    <div class="bar-row">
      <div class="bar-label">
        <div class="label-dot new"></div>
        <span class="label-text">{{ 'dashboard.new' | translate }}</span>
      </div>

      <div class="bar-wrapper">
        <div class="bar-background">
          <div
            class="bar-fill new"
            [style.width.%]="stats().newPct">
          </div>

          @if (stats().newValue === 0) {
            <div class="zero-indicator"></div>
          }
        </div>
      </div>
    </div>
  </div>

  <!-- Шкала -->
  <div class="scale-container">
    <div class="scale-wrapper">
      <!-- Сетка вертикальных линий -->
      <div class="scale-grid">
        @for (step of stats().scaleSteps; track $index) {
          <div
            class="grid-line"
            [style.left.%]="getScaleStepPosition($index)">
          </div>
        }
      </div>

      <!-- Основная горизонтальная линия -->
      <div class="scale-line"></div>

      <!-- Подписи шкалы -->
      @for (step of stats().scaleSteps; track $index) {
        <div
          class="scale-label"
          [style.left.%]="getScaleStepPosition($index)">
          <div class="scale-tick"></div>
          <div class="scale-value">{{ step }}</div>
        </div>
      }
    </div>
  </div>
</mat-card>
